// Vendor imports
import { Fancybox } from '@fancyapps/ui'
window.Fancybox = Fancybox;

import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
import intersect from '@alpinejs/intersect'
import resize from '@alpinejs/resize'
import breakpoint from 'alpinejs-breakpoints'
Alpine.plugin(intersect)
Alpine.plugin(resize)
Alpine.plugin(breakpoint)
Alpine.plugin(collapse)
Alpine.plugin(focus)
window.Alpine = Alpine
window.AlpineBreakpointPluginBreakpointsList = [
	'xs',
	'sm',
	'md',
	'lg',
	'xl',
	'2xl',
	'3xl',
	'max',
	'wide',
]

window.Alpine.start()

import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import 'lazysizes'
import 'lazysizes/plugins/object-fit/ls.object-fit'

// Module imports
import './modules/alpine-directives'
import './modules/animations'
import './modules/carousel'
import './modules/fancyapps'
import './modules/filters'
import './modules/formie'
import './modules/svgIconSprite'
import './modules/video-fit'
import './modules/locations-filter'
import './modules/people-filter'

document.addEventListener('DOMContentLoaded', () => {
	setTimeout(() => {
		document.body.classList.add('ready');
		window.dispatchEvent(new Event('resize'));
	}, 100);
});
